import { render } from "./DynamicAttributes.vue?vue&type=template&id=3c8b9cd8&scoped=true"
import script from "./DynamicAttributes.vue?vue&type=script&lang=js"
export * from "./DynamicAttributes.vue?vue&type=script&lang=js"

import "./DynamicAttributes.vue?vue&type=style&index=0&id=3c8b9cd8&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8b9cd8"],['__file',"webpack-assets/vue/templates/product/catalog/parts/DynamicAttributes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c8b9cd8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c8b9cd8', __exports__)) {
    api.reload('3c8b9cd8', __exports__)
  }
  
  module.hot.accept("./DynamicAttributes.vue?vue&type=template&id=3c8b9cd8&scoped=true", () => {
    api.rerender('3c8b9cd8', render)
  })

}


export default __exports__